import { parseCalendarDate } from "../../utils/date";

export function matchZone(match) {
  const value = match?.timeZone || match?.competitorInfo?.timeZone || "UTC";
  try { new Intl.DateTimeFormat("en", { timeZone: value }).format(); return value; } catch { return "UTC"; }
}
export function venueDay(value, timeZone = "UTC") {
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return null;
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(date).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}
export const matchVenueDate = (match, value = match.startDate || match.matchDate) => parseCalendarDate(venueDay(value, matchZone(match)));
export function venueInput(value, timeZone) {
  const day = venueDay(value, timeZone);
  if (!day) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return `${day}T00:00`;
  const time = new Intl.DateTimeFormat("en-GB", { timeZone, hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).format(new Date(value));
  return `${day}T${time}`;
}
export function matchHasEnded(match, now = new Date()) {
  const value = match.endDate || match.startDate || match.matchDate;
  if (!value) return false;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value) || !match.endDate) return venueDay(value, matchZone(match)) < venueDay(now, matchZone(match));
  const end = Date.parse(value);
  return Number.isFinite(end) && end <= now.getTime();
}
